import { 
  AddressCoordinates, 
  GeocodeResult,
  ReverseGeocodeResult,
  Coordinates 
} from "../types/distance.types";
import { showPopup } from "@/components/warnings/Popup";
import { handleApiError } from "@/lib/handleError";


export const fetchGeocode = async (
  address: string
): Promise<GeocodeResult | null> => {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/geocode?address=${encodeURIComponent(address)}`);

  const errorResult = await handleApiError(res);
  if (errorResult === null) return null;

  const coords = await res.json();

  if (!coords || !coords.latitude || !coords.longitude) {
    showPopup(
      "Unexpected Error",
      "An unexpected error has occured."
    )
    return null;
  }

  return { coordinates: {
      latitude: parseFloat(coords.latitude), 
      longitude: parseFloat(coords.longitude)
    }
  }
};


export const fetchGeocodeMulti = async (
  address: string,
  limit: number
): Promise<AddressCoordinates[] | null> => {
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/api/geocode-multi?address=${encodeURIComponent(address)}&limit=${limit}`
  );

  if (res.status === 404) {
    return [];
  }

  const errorResult = await handleApiError(res);
  if (errorResult === null) return null;

  const data = await res.json();

  if (!Array.isArray(data)) {
    showPopup(
      "Unexpected Error",
      "An unexpected error has occured."
    )
    return null;
  }

  const formatted = data
    .map((item: AddressCoordinates) => {
      const { address, coordinates } = item;

      if (
        !address ||
        typeof coordinates.latitude !== "number" ||
        typeof coordinates.longitude !== "number"
      ) {
        console.error("Invalid item in geocode-multi:", item);
        return { address: "", coordinates: {latitude:0, longitude:0} as Coordinates };
      }

      return {
        address,
        coordinates: coordinates as Coordinates,
      };
    });

  return formatted;
};


export const fetchReverseGeocode = async (
  lat: number,
  lon: number
): Promise<ReverseGeocodeResult | null> => {
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/api/reverse-geocode?lat=${lat}&lon=${lon}`
  );

  const errorResult = await handleApiError(res);
  if (errorResult === null) return null;

  const data = await res.json();
  return { address: data.address }
};